import * as React from "react";
import { Stream } from "./types";
import {Group} from "../Groups/types";

export interface StreamContextInterface {
    streams: Stream[];
    groups: Group[];
}

export const StreamContext = React.createContext<StreamContextInterface | null>(null);